import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.House.title',
    defaultMessage: 'Imóvel',
  },
  invalid: {
    id: 'app.containers.Checklist.House.invalid',
    defaultMessage: 'Preencha todos os itens',
  },
  finishButton: {
    id: 'app.containers.Checklist.House.finishButton',
    defaultMessage: 'Salvar itens do imóvel',
  },
});
